export const environment = {
  production: true,
  URL_SER_NODE: 'https://api.daroch.mx/',
  URL_SER_APP: 'https://api.daroch.mx/',
  URL_SER_WEB_PUSH: 'https://api.daroch.mx/api/web/push/',
  APP_ID: 'd9488c7a-05d3-480f-8a63-9304521drff655',
  STRIPE_PK: 'pk_live_T2FyTbveLxTXEIPX1vfiSyVp00glOt7mg0',
  PAYPAL_CLIENT_ID: 'AS0XjgANl3tcOjBf5howxhKZco1_fhp1g1MjSBN7UKefRiS9tcxd2VS796b9YNnlBJY4W5HV4hSyr6bN'
};